<div class="activity-container" #activityContainer (click)="showDetailsPanel(!detailsPanelOpened)">
  <div class="fields">
    <div class="no-status" *ngIf="activity.category === 'payroll'"></div>
    <!-- STATUS ORDER -->
    <div class="field item-status" *ngIf="activity.category === 'order'">
      <div
        [matTooltip]="activity.status | historyStatus : activity.category"
        matTooltipPosition="above"
      >
        <mat-icon class="status">
          <img [src]="setOrderImageStatus(activity.status)" />
        </mat-icon>
      </div>
    </div>

    <!-- STATUS TRANSACTION -->
    <div class="field item-status" *ngIf="activity.category === 'transaction'">
      <div
        [matTooltip]="activity.status | historyStatus : activity.category"
        matTooltipPosition="above"
      >
        <mat-icon class="status">
          <img [src]="setTransactionImageStatus(activity.status)" />
        </mat-icon>
      </div>
    </div>

    <!-- STATUS WITHDRAW -->
    <div class="field item-status" *ngIf="activity.category === 'withdraw'">
      <div
        [matTooltip]="activity.status | historyStatus : activity.category"
        matTooltipPosition="above"
      >
        <mat-icon class="status">
          <img [src]="setWithdrawImageStatus(activity.status)" />
        </mat-icon>
      </div>
    </div>

    <!-- STATUS DEPOSIT -->
    <div class="field item-status" *ngIf="activity.category === 'deposit'">
      <div matTooltip="Confirmado" matTooltipPosition="above">
        <mat-icon class="status">
          <img src="assets/icons/status/completed.svg" />
        </mat-icon>
      </div>
    </div>
    <!-- FECHA -->
    <div class="field item-date">
      <p class="date">
        <!-- Esto esta asi porque hay un error de back (llega creaTONtime en el socket de deposito) cuando se arregle remuevo esto y dejo solo creaTIONtime -->
        {{
          activity.creationTime
            ? (activity.creationTime | date : 'dd/MM')
            : (activity.creatonTime | date : 'dd/MM')
        }}
      </p>
      <p class="hour">
        {{
          activity.creationTime
            ? (activity.creationTime | date : 'HH:mm')
            : (activity.creatonTime | date : 'HH:mm')
        }}
      </p>
    </div>

    <!-- IMAGE -->
    <div class="field item-icon">
      <!-- IMAGE ORDER -->
      <img class="icon" *ngIf="activity.category === 'order'" [src]="coinIcon" alt="crypto icon" />

      <!-- IMAGE TRANSACTION / PAYROLL -->
      <img
        class="icon"
        *ngIf="activity.category === 'transaction' || activity.category === 'payroll'"
        [src]="
          activity.payment
            ? 'assets/icons/news/commerce-logo.svg'
            : ('assets/icons/crypto/' + activity.coin + '.svg' | lowercase)
        "
        alt="crypto icon loll"
      />

      <!-- IMAGE WITHDRAW / DEPOSIT -->
      <img
        class="icon"
        *ngIf="activity.category === 'withdraw' || activity.category === 'deposit'"
        [src]="'assets/icons/balance-' + activity.coin + '.svg' | lowercase"
        alt="fiat icon"
      />
    </div>

    <!-- DESCRIPTION -->
    <div class="field item-description">
      <p class="description">
        {{ activity.isBundle ? activity.description + bundleName : activity.description }}
      </p>
      <p class="username" *ngIf="activity.isGroup">
        {{ activity.username }}
      </p>
    </div>

    <!-- SEPARATOR (solo para orders y deposit) -->
    <div
      class="separator"
      *ngIf="activity.category === 'order' || activity.category === 'deposit'"
    ></div>

    <!-- DETALLE (para transactions) -->
    <div class="field item-tx" *ngIf="activity.category === 'transaction' && !activity.payment">
      <p class="address">
        <span>{{ activity.type === 0 ? 'Enviado desde: ' : 'Enviado a: ' }} </span>
        {{ activity.type === 0 ? activity.from : activity.to }}
      </p>
    </div>

    <!-- DETALLE (para withdraws) -->
    <div class="field item-tx" *ngIf="activity.category === 'withdraw'">
      <p class="id"><span>Id: </span>{{ activity.numberId ?? '' }}</p>
      <p class="cbu"><span>Enviado a: </span>{{ activity.destAccount.cbu }}</p>
    </div>

    <!-- DETALLE (para payroll) -->
    <div class="field item-tx" *ngIf="activity.category === 'payroll'">
      <p class="detail-item"><span>Empleado: </span> {{ activity.userId?.email || '-' }}</p>
      <p class="detail-item"><span>Empresa: </span>{{ activity.companyId?.email || '-' }}</p>
    </div>

    <!-- AMOUNT -->
    <div class="field item-amount">
      <!-- AMOUNT ORDER -->
      <div class="amount-box">
        <p class="amount-group" *ngIf="activity.isGroup">
          -
          {{
            (activity.operation === 'BUY' ? activity.price * activity.amount : activity.amount)
              | formatCoinAmount : activity.srcCoin
          }}
          {{ activity.srcCoin }}
          &nbsp;
        </p>
        <p class="amount win" *ngIf="activity.category === 'order' && !activity.isBundle">
          +
          {{
            activity.isGroup
              ? ((activity.operation === 'BUY' ? activity.amount : activity.price * activity.amount)
                | number : '0.3-6')
              : ((activity.operation === 'BUY' ? activity.amount : activity.price * activity.amount)
                | formatCoinAmount : activity.destCoin)
          }}
          {{ activity.destCoin }}
        </p>
      </div>
      <p
        class="amount"
        *ngIf="activity.category === 'order' && !activity.isBundle && !activity.isGroup"
      >
        -
        {{
          (activity.operation === 'BUY' ? activity.price * activity.amount : activity.amount)
            | formatCoinAmount : activity.srcCoin
        }}
        {{ activity.srcCoin }}
      </p>

      <p
        class="amount"
        [class.win]="activity.operation === 'SELL'"
        *ngIf="activity.category === 'order' && activity.isBundle"
      >
        {{ activity.operation === 'BUY' ? '-' : '+' }}
        {{
          activity.price * activity.amount
            | formatCoinAmount
              : (activity.operation === 'BUY' ? activity.srcCoin : activity.destCoin)
        }}
        {{ activity.operation === 'BUY' ? activity.srcCoin : activity.destCoin }}
      </p>
      <p class="price" *ngIf="activity.isGroup">
        1 {{ activity.operation === 'BUY' ? activity.destCoin : activity.srcCoin }}
        ≈
        {{
          (activity.price | number : '0.3-6') +
            ' ' +
            (activity.operation === 'BUY' ? activity.srcCoin : activity.destCoin)
        }}
      </p>

      <!-- AMOUNT TRANSACTION -->
      <div *ngIf="activity.category === 'transaction'">
        <p class="amount" [class.win]="activity.type === 0">
          {{ activity.type === 0 ? '+ ' : '- ' }}
          {{ +activity.amount | formatCoinAmount : activity.coin }}
          {{ activity.coin }}
        </p>
        <p class="amount fee" *ngIf="activity.type !== 0">
          <span [matTooltip]="'Costo de la operación'" matTooltipPosition="left">
            -
            {{ +activity.cost | formatCoinAmount : activity.coin }}
            {{ activity.coin }}
          </span>
        </p>
      </div>

      <!-- AMOUNT WITHDRAW -->
      <p class="amount" *ngIf="activity.category === 'withdraw'">
        - {{ activity.coin === 'ARS' ? 'AR$' : 'U$D' }}
        {{ activity.amount | formatCoinAmount : activity.coin }}
      </p>

      <!-- AMOUNT DEPOSIT -->
      <p class="amount win" *ngIf="activity.category === 'deposit'">
        + {{ activity.coin === 'ARS' ? 'AR$' : 'U$D' }}
        {{ activity.amount | formatCoinAmount : activity.coin }}
      </p>

      <!-- AMOUNT PAYROLL -->
      <p class="amount win" *ngIf="activity.category === 'payroll'">
        {{ activity.type === 0 ? '+ ' : '- ' }}
        {{ +activity.salary | formatCoinAmount : activity.coin }}
        {{ activity.coin }}
      </p>
    </div>

    <!-- ACTIONS -->
    <div class="field item-button">
      <!-- ACTIONS order -->
      <img
        class="button"
        src="assets/images/download-arrow.svg"
        alt="Download ticket"
        (click)="downloadOrder()"
        matTooltip="Descargar boleto"
        matTooltipPosition="above"
        *ngIf="activity.category === 'order' && !activity.isBundle && activity.orderId"
      />

      <!-- ACTIONS bundles transaction -->
      <div
        class="download"
        *ngIf="activity.category === 'order' && activity.isBundle"
        (click)="toggleCoinSelector('open'); $event.stopPropagation()"
      >
        <img
          class="button"
          src="assets/icons/expand.svg"
          alt="Download ticket"
          matTooltip="Descargar boleto"
          matTooltipPosition="above"
        />
        <div #coinSelector class="coin-selector-content" *ngIf="coinSelectorOpened">
          <div
            *ngFor="let coin of bundleCoins"
            class="coin-option"
            (click)="downloadBundleOrder(activity, coin)"
          >
            <img [src]="'/assets/icons/crypto/' + coin + '.svg'" alt="coin" />
            <div class="option-row">
              <p>{{ coin }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ACTIONS transaction -->
      <img
        class="button"
        src="assets/icons/link.svg"
        alt="View transaction"
        *ngIf="activity.category === 'transaction'"
        (click)="activity.payment ? showChargeDetails(activity.payment.id) : goToScan(activity)"
        matTooltip="Ver transacción"
        matTooltipPosition="above"
      />
    </div>
  </div>
  <div class="details-panel" [class.open]="detailsPanelOpened">
    <!-- DETALLE (para withdraws) -->
    <div class="item-tx" *ngIf="activity.category === 'withdraw'">
      <p class="id"><span>Id: </span>{{ activity.numberId ?? '' }}</p>
      <p class="cbu"><span>Enviado a: </span>{{ activity.destAccount.cbu }}</p>
    </div>
    <!-- DETALLE (para transactions) -->
    <div class="item-tx" *ngIf="activity.category === 'transaction' && !activity.payment">
      <!-- <p class="hash"><span>Id: </span> {{ activity.hash.length > 10 ? activity.hash : '-' }}</p> -->
      <p class="address">
        <span>{{ activity.type === 0 ? 'Enviado desde: ' : 'Enviado a: ' }} </span>
        {{ activity.type === 0 ? activity.from : activity.to }}
      </p>
    </div>

    <!-- DETALLE (para payroll) -->
    <div class="item-tx" *ngIf="activity.category === 'payroll'">
      <p class="detail-item"><span>Empleado: </span> {{ activity.userId?.email || '-' }}</p>
      <p class="detail-item"><span>Empresa: </span>{{ activity.companyId?.email || '-' }}</p>
    </div>

    <!-- ACTIONS -->
    <div class="item-button">
      <!-- ACTIONS order -->
      <img
        class="button"
        src="assets/images/download-arrow.svg"
        alt="Download ticket"
        matTooltip="Descargar boleto"
        matTooltipPosition="above"
        (click)="downloadOrder()"
        *ngIf="activity.category === 'order' && !activity.isBundle && activity.orderId"
      />

      <!-- ACTIONS transaction -->
      <img
        class="button"
        src="assets/icons/link.svg"
        alt="View transaction"
        *ngIf="activity.category === 'transaction'"
        (click)="activity.payment ? showChargeDetails(activity.payment.id) : goToScan(activity)"
        matTooltip="Ver transacción"
        matTooltipPosition="above"
      />
    </div>

    <!-- COIN SELECTOR BUNDLE -->
    <div
      class="coin-selector-content"
      *ngIf="activity.category === 'order' && activity.isBundle && detailsPanelOpened"
    >
      <div
        *ngFor="let coin of bundleCoins"
        class="coin-option"
        (click)="downloadBundleOrder(activity, coin)"
      >
        <img [src]="'/assets/icons/crypto/' + coin + '.svg'" alt="coin" />
        <div class="option-row">
          <p>{{ coin }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
